import styled from 'styled-components'
import NumberFormat from 'react-number-format'

interface InputProps {
  isFocused: boolean;
  isIncorrect?: boolean;
}

export const InputContainer = styled.div`
  &&& {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 0;
    small {
      font-weight: 400;
      font-size: 14px;
      line-height: 21px;
      color: #E84242;
    }
  }
`

export const InputLabel = styled.span<{ labelSize: 'small' | 'high', isIncorrect?: boolean }>`
  &&& {
    color: ${props => props.isIncorrect ? '#E84242' : '#353744'};
    font-weight: 900;
    font-size: ${props => props.labelSize === 'small' ? '14px' : '24px'};
    line-height: ${props => props.labelSize === 'small' ? '21px' : '34px'};
    margin-bottom: ${props => props.labelSize === 'small' ? '0' : '12px'};
  }
`

export const InputBox = styled.div<InputProps>`
  width: 100%;
  height: 40px;
  border: ${props => props.isIncorrect ? '1px solid #E84242' : props.isFocused ? '2px solid #3D6666' : '1px solid #C8C8C8'};
  background-color: #fff;
  padding-left: 12px;
  display: flex;
  align-items: center;
  justify-content: center;

  & svg {
    min-width: 20px;
    min-height: 20px;
    color: #C8C8C8;
    margin-right: 10px;
  }

  & span {
    font-weight: 900;
    font-size: 20px;
    line-height: 28px;
    color: #7B7C82;
    margin-right: 10px;
  }

  @media only screen and (max-width: 640px) {
    padding-left: 6px;

    & span {
      font-size: 16px;
      line-height: 16px;
      margin-right: 6px;
    }
  }
`

export const Input = styled(NumberFormat)`
  height: 100%;
  width: 100%;
  font-size: 16px;
  line-height: 24px;
  color: #353744;
  border: none;
  background-color: #fff;
`

export const CurrencyIcon = styled.p`
  font-weight: 800;
  font-size: 18px;
  line-height: 27px;
  color: #C8C8C8;
  opacity: 0.9;
  margin-right: 10px;
`